import { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import {
	createRoutesFromChildren,
	matchRoutes,
	RouterProvider,
	useLocation,
	useNavigationType,
} from 'react-router-dom';

import * as Sentry from '@sentry/react';

import { ConfigProvider } from 'antd';
import locale from 'antd/locale/ru_RU';

import { store } from 'app/appStore';
import { THEME } from 'shared/consts';

import 'shared/styles/index.scss';

import { sentryEnvironment } from '../../sentry-environment';

import appRouter from './appRouter';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

!!sentryDsn &&
	Sentry.init({
		dsn: sentryDsn,
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.replayIntegration(),
		],
		denyUrls: [
			// Chrome extensions
			/extensions\//i,
			/extension\//i,
			/^chrome:\/\//i,
			// Facebook flakiness
			/graph\.facebook\.com/i,
		],
		release: sentryEnvironment.release,
		tracesSampleRate: 1.0,
	});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<Provider store={store}>
			<ConfigProvider theme={THEME} locale={locale}>
				<RouterProvider router={appRouter} />
			</ConfigProvider>
		</Provider>
	</StrictMode>,
);
